document.addEventListener("DOMContentLoaded", () => {
  console.log('started'); // Keep this for debugging, remove in production
  const vatToggle = document.getElementById("vat-toggle-checkbox");
  // These selectors are correct for the HTML structure provided
  const vatIncludedLabel = document.querySelector(".switcher-label.vat-included-label");
  const vatExcludedLabel = document.querySelector(".switcher-label.vat-excluded-label");

  if (!vatToggle) {
    console.warn(
      "VAT toggle checkbox not found. Skipping price switcher initialization."
    );
    return;
  }

  // --- Core function to update price visibility and label appearance ---
  const updatePriceVisibility = (showInclVat) => {
    const pricesInclVat = document.querySelectorAll(
      ".vat-price-display.price-incl-vat"
    );
    const pricesExclVat = document.querySelectorAll(
      ".vat-price-display.price-excl-vat"
    );

    pricesInclVat.forEach((el) => (el.style.display = showInclVat ? "inline" : "none"));
    pricesExclVat.forEach((el) => (el.style.display = showInclVat ? "none" : "inline"));

    // Update label styles (add/remove 'active' class for CSS styling)
    // This correctly applies 'active' class to the currently selected label
    if (vatIncludedLabel) {
      vatIncludedLabel.classList.toggle("active", showInclVat);
    }
    if (vatExcludedLabel) {
      vatExcludedLabel.classList.toggle("active", !showInclVat);
    }
  };

  // --- Load preference from local storage on page load ---
  const savedPreference = localStorage.getItem("showPricesInclVat");

  // If preference exists, use it. Otherwise, use the initial checkbox state from HTML.
  if (savedPreference !== null) {
    vatToggle.checked = savedPreference === "true";
  } else {
    // If no preference saved, the initial state is determined by the 'checked' attribute in HTML.
    // This 'else' block ensures the checkbox's initial state from the HTML (if present) is respected.
    // If you always want to force a default (e.g., always show VAT Incl. initially if no preference),
    // you could uncomment the line below:
    // vatToggle.checked = true; // Forces default to VAT Incl. if no preference is saved
  }
  // Apply the initial visibility based on the loaded preference or default state
  updatePriceVisibility(vatToggle.checked);

  // --- Event listener for toggle change ---
  vatToggle.addEventListener("change", () => {
    const showInclVat = vatToggle.checked;
    updatePriceVisibility(showInclVat);
    localStorage.setItem("showPricesInclVat", showInclVat);
  });

  // --- Handle dynamic price updates (e.g., variant changes in Shopify) ---
  const observePriceChanges = () => {
    // Select specific parent elements that contain prices and might be updated by Shopify JS.
    // You might need to add more selectors specific to your Shopify theme.
    // These selectors (.product-price-wrapper, .price, .product__price) are generally good,
    // but inspect your theme's actual HTML for product prices for best results.
    const priceContainers = document.querySelectorAll(
      ".product-price-wrapper, .price, .product__price, .product-form__info, #ProductInfo-template--xxxxxxx-main"
      // Add other selectors if your theme uses different classes for price areas.
      // E.g., for Impulse theme, you might look at '.price-list', '.price--listing', '.product__info-container'
    );

    if (priceContainers.length === 0) {
      console.warn(
        "No specific VAT price containers found. Observing a broader area for changes. Consider adding more specific selectors for better performance."
      );
      // Fallback: observe a common parent like the main content area or even body if necessary.
      // Be cautious with document.body as it can be very performance-heavy.
      const fallbackObserver = new MutationObserver(() => {
        updatePriceVisibility(vatToggle.checked);
      });
      fallbackObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }

    priceContainers.forEach((container) => {
      const observer = new MutationObserver((mutationsList) => {
        // Optimization: Only re-apply if the mutation affects relevant VAT price elements
        // This makes the observer more efficient by not reacting to every DOM change.
        const vatPriceElementsChanged = mutationsList.some(mutation =>
            Array.from(mutation.addedNodes).some(node => node.nodeType === 1 && (node.matches('.vat-price-display') || node.closest('.vat-price-display'))) ||
            Array.from(mutation.removedNodes).some(node => node.nodeType === 1 && (node.matches('.vat-price-display') || node.closest('.vat-price-display'))) ||
            (mutation.target.nodeType === 1 && (mutation.target.matches('.vat-price-display') || mutation.target.closest('.vat-price-display'))) ||
            // This condition is important for changes to text content directly within price spans
            (mutation.target.nodeType === 3 && mutation.target.parentNode && (mutation.target.parentNode.matches('.vat-price-display') || mutation.target.parentNode.closest('.vat-price-display')))
        );

        if (vatPriceElementsChanged) {
            updatePriceVisibility(vatToggle.checked);
        }
      });

      // Observe for child additions/removals and changes anywhere in the subtree, including text content changes
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    });
  };

  // Initialize observer for existing price elements
  observePriceChanges();
});